import { emitEvent } from './eventBus';
import { handleSafeguard } from './requestErrorFunc';
import { SITE_STATUS } from '@/constant';
import { i18n } from '@/i18n';

interface paramsType {
  res: Record<string, any>;
  logout?: boolean;
  errorWay?: string;
  customErrorCodes?: number[];
}

const defaultParams = {
  res: {},
  logout: false,
  errorWay: 'showMessage'
};

export function dealWarning() {
  let currentMessageId: string | null = null;
  return function (params: paramsType, id: string | null = 'empty') {
    if (currentMessageId === id) {
      return;
    }
    const msgConfig = {
      ...defaultParams,
      ...params
    };
    const msg = showMessage(msgConfig);
    if (msg) {
      // 显示新的消息，并更新currentMessageId
      currentMessageId = id;
      DMessage({
        message: msg,
        type: 'info',
        onClose: () => {
          // 当消息关闭时，重置currentMessageId
          currentMessageId = null;
        }
      });
    }
  };
}
/**
 * 400010: 用户名密码错误
 * 400008: 登录被锁定
 * 400009: 登录惩罚升级
 * 400007: 验证码错误
 * 400017: 需要图形验证（天爱）
 * 400018: 需要图形验证（云片）
 * 400015: 异地登录/修改密码-缺失图片验证码
 */
const failCode = ['400010', '400008', '400009', '400007', '400018', '400017', '400015'];

export function showMessage({ res, logout, errorWay, customErrorCodes }: paramsType) {
  if (logout) {
    emitEvent('logout', true);
    return '';
  }
  let message: string = '';
  const status = res?.status || '';
  const error_code = res?.data?.error_code?.toString() || '';
  switch (status) {
    case 400: // 参数错误直接返回错误信息
      if (!failCode.includes(error_code)) {
        message = error_code === '400013' ? i18n.global.t('common.errorTips.tips1') : (res.data?.error_message || res.error_message);
      }
      break;
    case 401:
      emitEvent('logout', Boolean(localStorage.getItem('access_token')));
      break;
    case 403:
      if (SITE_STATUS.DISABLE && error_code === '10000') {
        handleSafeguard(errorWay || 'showMessage');
      } else {
        message = res.data.error_message || i18n.global.t('common.errorTips.tips2');
      }
      break;
    case 404:
      message = ''; // 404默认不弹出提示
      break;
    default:
      message = res?.data?.error_message || i18n.global.t('common.errorTips.tips3');
  }
  // 5xx错误码统一显示
  if (String(status).startsWith('5')) {
    DMessage.error(`${i18n.global.t('common.network.serviceError')}`);
    message = '';
  }

  if (customErrorCodes && customErrorCodes?.includes(status)) { // 这里将提示信息置空，得以在页面中自定义错误码处理
    message = '';
  }

  return message;
};

// 过滤审核文件
export function filterAuditResult(arr: any, filterName?: string) {
  return (arr || []).filter((item: any) => {
    /* 非路径相关接口审核过滤 例如commit列表 使用自定义的过滤字段 */
    if (filterName && !item[filterName]) {
      return false;
    }
    /* 路径有关的接口审核 例如目录树 分支名等 */
    if (!filterName && !item.name && !item.path) { // name和path不可能为空值 如果为空说明审核没有通过置空的。
      // 描述和commit信息等未通过不影响列表的显示 只影响字段的显示 所以不能直接通过整个审核状态过滤。
      return false;
    }
    // 如果需要处理 单条数据的描述有没有过审可以直接在单条数据的audit_result中获取。
    // if (item.audit_result && JSON.stringify(item.audit_result) !== '{}') {
    //   for (const i in item.audit_result) {
    //     if (item.audit_result[i].indexOf('branch:description') && item.audit_result[i]?.risk_level !== 'PASS') {
    //       //  PASS(通过)/REVIEW(待审核)/REJECT(不通过)
    //     }
    //   }
    // }
    // 旧审核 审核字段没有值通过
    if (item.show_type || item.audit_status) {
      return false;
    }
    return true;
  });
};

// 判断单个数据是否通过审核(仅适用于对应接口只有一个字段需要审核的情况)不适用于列表和多个字段需要审核。如分支列表，分支详情的接口需要同时审核名称和描述
export function isAuditPass(item: any) {
  // 审核状态不存在 通过
  if (item.audit_result && JSON.stringify(item.audit_result) === '{}') {
    return true;
  }
  // 审核状态为pass通过
  if (item.audit_result && JSON.stringify(item.audit_result) !== '{}') {
    let flag = false;
    for (const i in item.audit_result) {
      if (item.audit_result[i]?.risk_level === 'PASS') {
        flag = true;
      }
    }
    return flag;
  }
  return true;
}
